import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const AzureLogo = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '24',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 24'
    >
      <path
        d='M22.7998 20.4938C22.6321 20.4997 22.4651 20.5106 22.2973 20.5114C17.4066 20.5114 12.5159 20.5114 7.62606 20.5114C7.45996 20.5114 7.29386 20.5114 7.12776 20.5114C7.12356 20.4796 7.11937 20.4477 7.11517 20.4166C7.74098 20.3034 8.36511 20.1843 8.99176 20.0769C11.3037 19.6801 13.6165 19.2867 15.9294 18.8907C16.3194 18.8236 16.3412 18.7666 16.0938 18.4562C14.5628 16.5326 13.0352 14.6065 11.4933 12.6922C11.2853 12.4338 11.2316 12.2149 11.3465 11.8969C12.1611 9.63612 12.9572 7.36944 13.7633 5.10613C13.807 4.98449 13.8028 4.79155 13.9789 4.78903C14.1199 4.78651 14.1484 4.95681 14.2071 5.06251C17.0266 10.0799 19.8453 15.0981 22.6648 20.1155C22.7059 20.1885 22.7545 20.2573 22.7998 20.3277V20.4955V20.4938Z'
        fill={primaryColorToUse}
      />
      <path
        d='M1.3251 18.4808C2.06584 17.3114 2.69249 16.0774 3.37199 14.8736C4.45667 12.9509 5.51786 11.0147 6.60506 9.0937C6.90705 8.55933 7.44981 8.24726 7.89778 7.85299C9.51348 6.43359 11.1468 5.03349 12.7742 3.62667C12.8447 3.56628 12.8967 3.4698 13.0569 3.49161C12.8581 4.12162 12.5477 4.69458 12.2826 5.28431C10.3373 9.6029 8.38098 13.9156 6.43392 18.2342C6.31396 18.501 6.18226 18.6662 5.85257 18.662C4.34342 18.6453 2.83426 18.6503 1.3251 18.6478V18.48L1.3251 18.4808Z'
        fill={primaryColorToUse}
      />
    </svg>
  );
};
